export default __webpack_public_path__ + "static/spiritual-india-places-1-de061bd12462c81699ea4323571335bd.jpg";